<template>
  <a href="profile.html" class="notification">
    <div class="notification-content item-list">
      <div class="item-content">
        <div class="item-inner me-3">
          <p class="title text-black text-start">Lily MacDonald</p>
          <small class="mb-0 text-dark text-justify">Lorem ipsum dolor sit ameet Lorem ipsum dolor sit ameet Lorem ipsum dolor sit ameet..</small>
        </div>
        <div  class="ms-auto font-10 text-dark d-flex align-self-center justify-content-center align-items-center">
          <svg class="me-1" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="#787878" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M6 3V6L8 7" stroke="#787878" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          12 min ago
        </div>
      </div>
    </div>
  </a>
</template>

<script setup>

import {onMounted} from "vue";

// eslint-disable-next-line no-undef
defineProps({
  name: {
    type: String,
    default: "Category"
  },
  id: {
    type: String,
    default: "1"
  }
})

onMounted(() => {
})

</script>

<style scoped>
.notification{
  box-shadow: 0 0 0 0 transparent;
  border: 0.2 solid var(--border-color);
  padding: 5px 10px;
}
.notification .notification-content .item-content{
  margin: 0;
}
</style>